import React from 'react'
import {injectIntl} from 'react-intl'
import Select from '@mui/material/Select'
import MenuItem from '@mui/material/MenuItem'
import TextField from '@mui/material/TextField'
import {periods} from 'utils/enums/formula'

class Period extends React.Component {
    constructor(props) {
        super(props)

        this.state = {
            period: this.props.value ? this.props.value.period : periods.years.code,
            offset: this.props.value ? this.props.value.offset : null
        }
    }

    handleChange = (e) => {
        this.setState({
            [e.target.name]: e.target.value
        }, () => this.handleUpdate())
    }

    handleUpdate = () => {
        this.props.changeValue({period: this.state.period, offset: this.state.offset})
    }

    render() {
        const { intl } = this.props

        return (
            <React.Fragment>
                <TextField variant="standard"
                    name='offset'
                    onChange={this.handleChange}
                    defaultValue={this.state.offset}
                    type='number'
                />
                {!this.props.between &&
                    <Select
                        style={{ margin: '0 10px', minWidth: '100px' }}
                        onChange={this.handleChange}
                        value={this.state.period}
                        name='period'
						variant="standard"
                    >
                        {Object.values(periods).map((item, index) =>
                            <MenuItem key={index} value={item.code}>
                                {intl.formatMessage({id: `config.formula_period_${item.label}`})}
                            </MenuItem>
                        )}
                    </Select>
                }
            </React.Fragment>
        )
    }
}

export default injectIntl(Period)
